import React from 'react'

const CreditsList = () => {
  return (
    <div className='rsidebar__credit-list'>
        <div className='rsidebar__credit-artist'>
            <div className='rsidebar__credit-artist-name'>Shankar Mahadevan</div>
            <div className='rsidebar__credit-artist-role'>main artist</div>
        </div>
        <div className='rsidebar__credit-follow'>
            <div className='rsidebar__credit-follow-btn'>Follow</div>
        </div>
    </div>
  )
}

export default CreditsList